var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH674(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#ffdf97;}.cls-5{fill:#ea8b49;}.cls-6,.cls-7{fill:#fff;}.cls-8{fill:#fcce0e;}.cls-9{fill:#ffbf57;}.cls-10{fill:#efecea;}.cls-11{fill:#fde157;}.cls-12{fill:#cecece;}.cls-13{fill:#d37a3d;}.cls-14{fill:#6dd3ce;}.cls-7{opacity:0;}.cls-2{stroke:#ffd15c;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 63.24,
    cy: 136.32,
    r: 12.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M179.76,123.42l-8.35-5.15c-1.41-.87-1.69-2.81-.59-4.05l2.6-2.91c1.35-1.5,.6-3.9-1.37-4.37l-35.27-8.45c-2.24-.54-4.06,1.83-2.97,3.85l16.05,29.92c.87,1.63,3.1,1.9,4.34,.52l4.49-5.01c1.11-1.24,3.08-1.17,4.1,.15l5.35,6.95c.96,1.24,2.78,1.39,3.93,.32l8.09-7.55c1.29-1.2,1.08-3.3-.42-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M126.19,133.33l-24.68-2.35c-1.99-.19-3.6-1.69-3.93-3.66l-3.35-20.15c-.23-1.36-2.11-1.55-2.6-.26-1.88,5.01-4.87,13.03-7.14,19.16-.69,1.87-2.56,3.05-4.55,2.86l-24.61-2.35c-1.97-.19-3.72,1.26-3.91,3.23l-2.83,29.71c-.19,1.97,1.26,3.72,3.23,3.91l70.85,6.75c1.97,.19,3.72-1.26,3.91-3.23l2.83-29.71c.19-1.97-1.26-3.72-3.23-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M174.85,77.69l-39.08,3.42-69.07,6.04-39.08,3.42c-1.82,.16-3.17,1.77-3.01,3.59l2.58,29.52c.16,1.82,1.77,3.17,3.59,3.01l39.08-3.42,69.07-6.04,39.08-3.42c1.82-.16,3.17-1.77,3.01-3.59l-2.58-29.52c-.16-1.82-1.77-3.17-3.59-3.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.04,56.31c30.94-34.97,89.7-26.03,108.8,16.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.51,64.85c.38-.6,.78-1.19,1.18-1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.6,155.28c-53.28,34.95-119.68-17.38-98.65-77.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.4,148.25c-.49,.47-.99,.92-1.5,1.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.6,50.74c-5.87-7.8-10.88-23.31-10.88-23.31h-4.6s-5.01,15.52-10.88,23.31l-1.88,2.48c0,6.96,6.44,9.64,15.07,9.73,8.62-.09,15.07-2.77,15.07-9.73l-1.88-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.08,46.97c-3.01-4-5.58-11.95-5.58-11.95h-2.36s-2.57,7.96-5.58,11.95l-.96,1.27c0,3.57,3.3,4.94,7.72,4.99,4.42-.05,7.72-1.42,7.72-4.99l-.96-1.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.44,23.52c-2.18,0-3.95-2.82-3.95-4.14,0-.22-.47-.22-.47,0,0,1.27-1.63,4.14-4.2,4.14-.22,0-.22,.47,0,.47,2.24,0,4.2,3.07,4.2,4.14,0,.22,.47,.22,.47,0,0-1.27,1.82-4.14,3.95-4.14,.22,0,.22-.47,0-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M123.7,59.92c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M138.27,130.72c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M177.93,72.15c-.16-1.82-1.77-3.17-3.59-3.01l-108.15,9.46h0l-39.08,3.42c-1.82,.16-3.17,1.77-3.01,3.59l2.58,29.52c.16,1.82,1.77,3.17,3.59,3.01l147.24-12.88c1.82-.16,3.17-1.77,3.01-3.59l-2.58-29.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 63.77,
    y: 67.45,
    width: 115.19,
    height: 36.25,
    rx: 3.31,
    ry: 3.31,
    transform: "translate(-6.99 10.9) rotate(-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 24.69,
    y: 70.87,
    width: 115.19,
    height: 36.25,
    rx: 3.31,
    ry: 3.31,
    transform: "translate(-7.44 7.51) rotate(-5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M119.46,121.91l-24.68-2.35c-1.99-.19-3.6-1.69-3.93-3.66l-3.35-20.15c-.23-1.36-2.11-1.55-2.6-.26-1.88,5.01-4.87,13.03-7.14,19.16-.69,1.87-2.56,3.05-4.55,2.86l-24.61-2.35c-1.97-.19-3.72,1.26-3.91,3.23l-2.83,29.71c-.19,1.97,1.26,3.72,3.23,3.91l70.85,6.75c1.97,.19,3.72-1.26,3.91-3.23l2.83-29.71c.19-1.97-1.26-3.72-3.23-3.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 63.24,
    cy: 136.32,
    r: 14.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 63.41,
    cy: 133.68,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.81,145.84s1.93-7.93,8.69-7.41,8.59,6.81,8.6,10.89c0,4.08-20.56,4.02-17.29-3.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 61.22,
    cy: 134,
    rx: 1.88,
    ry: 1.22,
    transform: "translate(-77.08 184.77) rotate(-85.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 65.52,
    cy: 134.33,
    rx: 1.88,
    ry: 1.22,
    transform: "translate(-73.43 189.37) rotate(-85.61)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 81.85,
    y: 131.54,
    width: 29.13,
    height: 5.52,
    rx: 1.24,
    ry: 1.24,
    transform: "translate(14.4 -9.25) rotate(5.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.03,146.9l-15.15-1.63c-.68-.07-1.17-.68-1.1-1.36l.31-3.03c.07-.68,.68-1.17,1.36-1.1l15.15,1.63c.68,.07,1.17,.68,1.1,1.36l-.31,3.03c-.07,.68-.68,1.17-1.36,1.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M173.04,111.99l-8.35-5.15c-1.41-.87-1.69-2.81-.59-4.05l2.6-2.91c1.35-1.5,.6-3.9-1.37-4.37l-35.27-8.45c-2.24-.54-4.06,1.83-2.97,3.85l16.05,29.92c.87,1.63,3.1,1.9,4.34,.52l4.49-5.01c1.11-1.24,3.08-1.17,4.1,.15l5.35,6.95c.96,1.24,2.78,1.39,3.93,.32l8.09-7.55c1.29-1.2,1.08-3.3-.42-4.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 155.45,
    cy: 100.08,
    r: 3.09
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH674);
export default __webpack_public_path__ + "static/media/H67-4.361081d98fab8f68af71a0a5f7d5dc0e.svg";
export { ForwardRef as ReactComponent };